const bootstrapModalHash = (Modal) => {
    const getModal = () => {
        const modal = document.querySelector('.modal.show');
        return modal ? Modal.getOrCreateInstance(modal) : null;
    };

    document.addEventListener('show.bs.modal', event => {
        window.location.hash = event.target.id;

        if(event.target.id == "modal-order" && event.relatedTarget.dataset.skuter) event.target.querySelector('input[name="skuter"]').value = event.relatedTarget.dataset.skuter
    });

    document.addEventListener('hide.bs.modal', event => {
        if (window.location.hash === '#' + event.target.id) {
            history.replaceState(null, null, ' ');
        }
    });

    addEventListener("hashchange", () => {
        const openModal = getModal();
        if (openModal && window.location.hash !== "#" + openModal.id) {
            openModal.hide();
        }
    });
};

export default bootstrapModalHash;
